module.exports = __webpack_public_path__ + "static/img/txt-2-1.4daeccb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zbqfBrand/txt-2-1.png
// module id = n08V
// module chunks = 0